import * as React from 'react';
import { produce } from 'immer';
import { LifeCycleTypes } from '@formily/core';
import { genValidateField } from './extendsEffects/validateField';
import { genOnArrayFieldsChange } from './extendsEffects/onArrayFieldsChange';
import { genOnArrayFieldChange } from './extendsEffects/onArrayFieldChange';
import { genOnFieldValueChange } from './extendsEffects/onFieldValueChange';
import { genOnMultiFieldsValueChange } from './extendsEffects/onMultiFieldsValueChange';
import { genLinkedFieldProps } from './extendsEffects/linkedFieldProps';

const handleEffects = effects => Array.isArray(effects) ? (...arr) => effects.forEach(e => e(...arr)) : effects;

export const useExtendsEffects = props => {
  const effectsIn = props.effects;
  const recordFormChange = props.recordFormChange;
  const formRef = React.useRef({});
  const setRefState = React.useCallback(fun => {
    const state = produce(formRef.current, fun);
    formRef.current = state;
  }, []);
  const getRefState = React.useCallback(() => {
    return formRef.current;
  }, []);
  const formOpt = {
    setRefState,
    getRefState
  };
  const effects = React.useCallback(($, form) => {
    if (!effectsIn) {
      return;
    }

    $.onFieldValueChange = genOnFieldValueChange($, form);
    $.onArrayFieldChange = genOnArrayFieldChange($, form);
    $.onArrayFieldsChange = genOnArrayFieldsChange($, form);
    $.onMultiFieldsValueChange = genOnMultiFieldsValueChange($, form);
    $.validateField = genValidateField($, form);
    $.linkedFieldProps = genLinkedFieldProps($, form);
    $.onFieldValueChange('*', s => {
      recordFormChange && recordFormChange(s);
    });
    $.LifeCycleTypes = LifeCycleTypes;
    handleEffects(effectsIn)($, form, formOpt); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return effects;
};
//# sourceMappingURL=es/Form/extendsEffects.js.map